export const SITE_URL = "https://sbsproperties.co.ke";
export const SITE_NAME = "SBS Properties";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.jpg`;
export const DEFAULT_DESCRIPTION =
  "SBS Properties — Mombasa's trusted real estate partner since 1952. Property management, strategic sales, and premium rentals across the East African coast.";

export const absUrl = (path) => {
  if (!path) return DEFAULT_OG_IMAGE;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const truncate = (text, max = 160) => {
  if (!text) return DEFAULT_DESCRIPTION;
  const clean = String(text).replace(/\s+/g, " ").trim();
  return clean.length <= max ? clean : `${clean.slice(0, max - 1).trimEnd()}…`;
};

export const LOGO_URL = `${SITE_URL}/api/files/sbs-properties/uploads/17902f68-7668-4fa5-9339-1cf504cd96d6.png`;

// Facebook/WhatsApp need a JPEG at a sane size. Route ALL uploaded images through
// the backend converter so every preview is a standardized 1200x630 JPEG, regardless
// of the original format (WebP/PNG/JPEG) or dimensions. External URLs pass through.
export const ogImage = (path) => {
  if (!path) return DEFAULT_OG_IMAGE;
  const m = String(path).match(/\/api\/files\/(.+)$/);
  if (m) {
    return `${SITE_URL}/api/og-image.jpg?key=${encodeURIComponent(m[1])}`;
  }
  return absUrl(path);
};

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: SITE_NAME,
  url: SITE_URL,
  logo: LOGO_URL,
  image: DEFAULT_OG_IMAGE,
  description: DEFAULT_DESCRIPTION,
  telephone: "+254709746298",
  email: "info@sbsproperties.co.ke",
  foundingDate: "1952",
  address: {
    "@type": "PostalAddress",
    streetAddress: "SBS Markiti Complex, 1st Floor, Abdel Nasser Road",
    addressLocality: "Mombasa",
    postalCode: "80100",
    addressCountry: "KE",
  },
  areaServed: "Mombasa and the Kenyan Coast",
  sameAs: [
    "https://www.instagram.com/sbs.properties.llc/",
    "https://www.facebook.com/sbs.properties.llc/",
    "https://www.linkedin.com/company/sbsproperties",
  ],
};
